import {
  pageStyle,
  secondaryButtonStyle,
  chipStyle,
} from '../../styles/styles';

export { pageStyle };

export const waitingRoomCardStyle = {
  width: '100%',
  maxWidth: '1120px',
  background: '#ffffff',
  border: '1px solid #dbe6ef',
  borderRadius: 20,
  padding: 28,
  boxShadow: '0 18px 60px rgba(15, 23, 42, 0.08)',
};

export const waitingRoomPreviewStyle = {
  position: 'relative',
  marginTop: 18,
  minHeight: 360,
  borderRadius: 20,
  background: 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  color: '#ffffff',
  overflow: 'visible',
};

export const waitingRoomPreviewSurfaceStyle = {
  position: 'absolute',
  inset: 0,
  borderRadius: 20,
  overflow: 'hidden',
  background: 'transparent',
  zIndex: 1,
};

export const waitingRoomControlsStyle = {
  marginTop: 18,
  display: 'flex',
  gap: 10,
  alignItems: 'center',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
};

export const waitingRoomContentStyle = {
  display: 'flex',
  gap: 32,
  alignItems: 'flex-start',
};

export const waitingRoomContentResponsiveStyle = {
  ...waitingRoomContentStyle,
  flexWrap: 'wrap',
  alignItems: 'center',
};

export const waitingRoomLeftStyle = {
  flex: '1 1 0',
  minWidth: 0,
};

export const waitingRoomLeftResponsiveStyle = {
  ...waitingRoomLeftStyle,
  flex: '1 1 560px',
  minWidth: 320,
};

export const waitingRoomRightStyle = {
  width: 320,
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 18,
  paddingTop: 4,
};

export const waitingRoomRightResponsiveStyle = {
  ...waitingRoomRightStyle,
  flex: '0 1 320px',
  width: 'min(320px, 100%)',
  alignSelf: 'center',
  margin: '0 auto',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
};

export const waitingRoomPreviewControlsStyle = {
  position: 'absolute',
  bottom: 16,
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: 8,
  zIndex: 60,
};

export const previewControlsStyle = {
  ...waitingRoomPreviewControlsStyle,
  gap: 10,
};

export const waitingRoomHeaderStyle = {
  marginBottom: 16,
};

export const waitingRoomTitleStyle = {
  margin: 0,
  color: '#111827',
  fontSize: 30,
  letterSpacing: '-0.02em',
};

export const waitingRoomSubtitleStyle = {
  marginTop: 8,
  color: '#64748b',
  fontSize: 14,
  lineHeight: 1.5,
};

export const waitingRoomCameraOffOverlayStyle = {
  position: 'absolute',
  inset: 0,
  background: 'linear-gradient(180deg, #18324a 0%, #102437 100%)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  opacity: 0.9,
};

export const waitingRoomCameraOffAvatarStyle = {
  width: 72,
  height: 72,
  borderRadius: '50%',
  background: '#2a4a65',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 24,
  fontWeight: 700,
};

export const waitingRoomCameraOffTextStyle = {
  fontSize: 13,
};

export const waitingRoomPreviewHeaderStyle = {
  position: 'absolute',
  top: 16,
  left: 16,
  right: 16,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  pointerEvents: 'none',
};

export const waitingRoomPreviewChipStyle = {
  background: 'rgba(7, 23, 36, 0.42)',
  backdropFilter: 'blur(8px)',
  color: '#fff',
  borderRadius: 999,
  padding: '6px 10px',
  fontSize: 12,
  fontWeight: 600,
  pointerEvents: 'none',
};

export const waitingRoomJoinInfoStyle = {
  fontSize: 13,
  color: '#21374d',
};

export const primaryButtonStyle = {
  border: 'none',
  background: '#2eaac7',
  color: '#ffffff',
  borderRadius: 999,
  height: 44,
  padding: '0 18px',
  fontSize: 13,
  fontWeight: 600,
  cursor: 'pointer',
};

export const waitingRoomLeaveButtonStyle = {
  ...secondaryButtonStyle,
  minWidth: 92,
};

export { chipStyle };
